import CustomRadioButton from "../../general/CustomRadioButton";
import {useState} from "react";
import {Radio, Row} from "antd";
import CustomButton from "../../general/CustomButton";
import {useLocation, useNavigate, useOutletContext} from "react-router";

const ThirteenthStep = ({question}) =>{

    const [value, setValue] = useState('yes');
    const {info, setInfo} = useOutletContext()
    const navigate = useNavigate()
    const location = useLocation()

    const nextPageHandler = () => {
        if (location.pathname.includes('partner')){
            navigate('/questions/partner/14')
        }else{
            navigate('/questions/14')
        }
    }

    const prevPageHandler = ()=>{
        if (location.pathname.includes('partner')) {
            navigate('/questions/partner/12')
        } else {
            navigate('/questions/12')
        }
    }

    const onChange = (e) => {
        setValue(e.target.value);
        setInfo({...info,nationally_known_personality:e.target.value})
    };

    return (
        <div style={{textAlign:'right'}}>
            <div>{question}</div>
            <Radio.Group onChange={onChange} value={value}>
                <div><CustomRadioButton isChecked={value==='yes'} value={'yes'} text={'بله'} width={150} /></div>
                <div><CustomRadioButton isChecked={value==='no'} value={'no'} text={'خیر'} width={150} /></div>
            </Radio.Group>
            <div style={{width: '100%',display:'flex',alignItems:'center',justifyContent:'space-between',marginTop:'1rem'}}>
                <CustomButton
                    text={'مرحله بعد'}
                    width={150}
                    style={{marginTop: '1rem'}}
                    onClick={nextPageHandler}
                />
                <CustomButton
                    text={'مرحله قبل'}
                    ghost={true}
                    width={150}
                    style={{marginTop: '1rem'}}
                    onClick={prevPageHandler}
                />
            </div>
        </div>
    )
}

export default ThirteenthStep